import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivateQuoteDetailsResponse} from "../../../api/models/activate-quote-details-response";
import {ActivationControllerService} from "../../../api/services/activation-controller.service";
import {QuotationService} from "../../../services/quotation-service/quotation.service";
import {DeclineQuoteSaveRequest} from "../../../api/models/decline-quote-save-request";
import {LeadService} from "../../../services/lead-service/lead.service";
import {GtmService} from "../../../services/gtm-service/gtm.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-quote-activate-details',
  templateUrl: './activation-quote-activate-details.component.html'
})
export class ActivationQuoteActivateDetailsComponent implements OnInit {

  activateQuoteResponse: ActivateQuoteDetailsResponse;
  declineReason: DeclineQuoteSaveRequest = {
    reasonCode: -1
  };
  @ViewChild('openModal') openModal: ElementRef;
  retrievingQuoteSchedule = false;
  termsAccepted = false;
  showSpinner = false;

  constructor(public quotationService: QuotationService,
              private _activationController: ActivationControllerService,
              private _leadService: LeadService,
              private _gtmService: GtmService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this._loadView();
    this.quotationService.scrollToTop();
  }

  displayModal(): void {
    this.openModal.nativeElement.click();
    this._reloadJCF();
  }

  selectionChange(value: any): void {
    this.declineReason.reasonCode = value;
  }

  activateQuote(): void {
    this.showSpinner = true;
    this.quotationService.scrollToTop();
    this._activationController.activationV1ActivateGet().subscribe((response) => {
      this.showSpinner = false;
      this._gtmService.postGtmEvent('form_step_complete', 'activate_plan', 9);
      if (response && !response.referred) {
        // go to breakout screen
          this._leadService.insureRecommendedQuote = 'Activated plan';
          this._leadService.updateLead().subscribe();
          this.getRegistrationUrl();
      } else if (response && response.referred) {
        this.modalService.dismissAll();
        this._leadService.insureRecommendedQuote = 'Entity matching required';
        this._leadService.updateLead().subscribe();
        this.quotationService.quoteActivationReferred = true;
        this.quotationService.error = true;
      }
    }, error => {
      this.modalService.dismissAll();
      this.showSpinner = false;
      this.quotationService.error = true;
    });
  }

  declineQuote(): void {
    this._activationController.activationV1DeclineQuoteDetailsPut(this.declineReason).subscribe((response) => {
        //go to home screen
        window.parent.location.href = '/portal';
    }, error => {
      this.quotationService.error = true;
    });
  }

  getQuoteSchedule(): void {
    if (!this.retrievingQuoteSchedule) {
      this.retrievingQuoteSchedule = true;
      this._activationController.activationV1QuoteScheduleGet().subscribe((response) => {
        console.warn('Retrieved schedule');
        this.retrievingQuoteSchedule = false;
        if (response) {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response, 'Quote Schedule.pdf');
          } else {
            const fileName = 'Quote Schedule.pdf';
            this.downloadFile(response, fileName);
          }
        }
      }, error => {
        console.warn('Failed to get schedule');
        this.quotationService.error = true;
      });
    }
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: "lg"});
  }

  private getRegistrationUrl(): void {
    this.quotationService.getRegistrationUrl().subscribe((response: string) => {
      if (response) {
        window.parent.location.href = response;
      }
    }, error => {
      this.quotationService.error = true;
    });
  }

  private downloadFile(response: any, fileName: string) {
    console.warn('Downloading schedule');
    const url = window.URL.createObjectURL(response);
    const a = document.createElement('a');
    window.open(url, '_blank');
    window.URL.revokeObjectURL(url);
    console.warn('Downloading schedule failed');
  }

  private _loadView(): void {
    this._activationController.activationV1ActivateQuoteDetailsGet().subscribe((response) => {
      if (response) {
        this.activateQuoteResponse = response;
        this._reloadJCF();
      }
    }, error => {
      this.quotationService.error = true;
    });
  }

  private _reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }
}
